import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkZero'
})
export class CheckZeroPipe implements PipeTransform {

  transform(value: string): string {
    const valueTrimmed = value.trim()
    if (valueTrimmed == '.00' || valueTrimmed == '0' || valueTrimmed == '' || valueTrimmed == '.0') {
      return '0.00'
    }
    return value.toString();
  }

}
